import { useDebugValue, useState } from "react"
import { useParams } from "react-router-dom"
import styled from "styled-components"
import { payLoan } from "Features/api/api"
import { useDispatch } from "react-redux"
import { payContribution } from "Features/api/api"

const ContributionPaymentForm=( {setIsModalOpen})=>{
    
   
    const dispatch=useDispatch()
    const[paymentData, setPaymentData] =useState({
       amount_paid:'' ,
       payment_Reference_Code:'',
       
    })
    const currentDate = new Date();
    const contributionMonth = currentDate.toISOString().split('T')[0];

    
    const paymentDate = currentDate.toISOString();

    const handleOnchange=(e)=>{
        const{name, value}=e.target
        setPaymentData(
            {
                ...paymentData, [name]: value
            }
        )
    }

   const contributionData={
    amount_paid: Number(paymentData.amount_paid),
     contribution_month: contributionMonth,
    payment_date: paymentDate, 
    payment_Reference_Code:paymentData.payment_Reference_Code
   }
   
    
  const handleSubmit=(e)=>{
      e.preventDefault()
      console.log(contributionData)
      dispatch(payContribution(contributionData))
      setIsModalOpen(false)
  }
    return(
        <Container>
            <h2>Make Your Payment Below</h2>
            <p> Please note that all payments are subject to approval by the Sec-General and the Treasurer.<br/>
                 Any payment not approved by both of them is considered incomplete</p>
              <PaymentForm onSubmit={handleSubmit}>
              
            <FormOuterRow>

            
             <Form_Row>
             <label htmlFor="amount_paid">
                Amount:
                </label>
                <input type="number" onChange={handleOnchange} id='amount_paid' name="amount_paid" placeholder="Input the amount you want to pay: e.g 2000.00 " required />
                
             </Form_Row>
             <Form_Row>
             <label htmlFor=" payment_Reference_Code">
               Payment Reference Code:
                </label>
                <input type="text" onChange={handleOnchange} id='payment_Reference_Code' name="payment_Reference_Code" placeholder="Input MPesa or Bank Payment RefCode" required />
                
             </Form_Row>
             
                </FormOuterRow>    
             
                <AuthButtons>
       <SignUpBtn type="submit" > submit Payment</SignUpBtn>
       </AuthButtons>
        
              </PaymentForm>
        </Container>
    )
}

const Container=styled.div`
display:flex;
flex-direction: column;
justify-content:flex-start;
overflow:hidden;
width:80%;
h2{
    display:flex;
    justify-content:flex-start;
    margin-left:0px;
}
p{
    display:flex;
    width:80%;
    justify-content:flex-start;
   

}
`
const PaymentForm=styled.form`
margin-left:0px;
display:flex;
flex-direction:column;
justify-content:flex-start;
width: 100%;

`
const FormOuterRow=styled.div`
display:flex;
flex-direction:column;
justify-content:flex-start;
margin-bottom:10px;
width:80%;
`
const Form_Row = styled.div`

margin-bottom:10px;
margin-right:5px;
display:flex;
flex-direction:column;
justify-content:flex-start;
width:100%;

input {
  border: none; /* Remove default border */
  border-bottom: 1px solid #353935; /* Add a single line at the bottom */
  outline: none; /* Remove outline when focused */
  width:80%; 
  
}
select {
  margin-top: 10px;  
  border: none; /* Remove default border */
  border-bottom: 1px solid #353935; /* Add a single line at the bottom */
  outline: none; /* Remove outline when focused */
  width:100%; 
  
}
label{
    font-size:12px;
}
@media (max-width: 768px) {
    .label{
        font-size:8px;
    }
    
}
`
const StyledForm=styled.form`
margin-left:0px;
display:flex;
flex-direction:column;
justify-content:flex-start;
width:100%;
padding-left:5px;
`
const AuthButtons = styled.div`
display: flex;
align-items:center;
flex-direction:row;

margin-top:20px;
width:100%;
padding-left: 0px;
margin-left:0px;
`
const SignUpBtn = styled.button`
margin-left:80px;
display:flex;
justify-content:center;
cursor:pointer;
padding: 10px 30px;
border-radius:10px;
background-color: #E2725B;
/* background-color:red; */
color:#f9f9f9;
border:none;
width:50%;
border-color:#E2725B;
@media (max-width: 768px) {
    font-size:10px;
    padding: 5px 15px;
}
`
export default ContributionPaymentForm